import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, TooltipPosition, MatSnackBar } from '@angular/material';
import { AccessCodeDialogComponent } from '../access-code-dialog/access-code-dialog.component';
import { FormControl } from '@angular/forms';
import * as XLSX from 'xlsx';
import { AddHiringDriveComponent } from '../add-hiring-drive/add-hiring-drive.component';
import { DriveEventService } from 'src/app/services/drive-event/drive-event.service';
import { User } from 'src/app/model/user.model';
import { BranchDataDTO } from 'src/app/model/branch-data-dto.model';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { ErrorStatusDialogComponent } from '../error-status-dialog/error-status-dialog.component';
import { DriveComponent } from '../drive/drive.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-drive-event',
  templateUrl: './drive-event.component.html',
  styleUrls: ['./drive-event.component.scss']
})
export class DriveEventComponent implements OnInit {
  positionOptions: TooltipPosition[] = ['after', 'before', 'above', 'below', 'left', 'right'];
  arrayBuffer: any;
  allUser: User[] = [];
  excelData: any;
  position = new FormControl(this.positionOptions[0]);
  branchDataDto: BranchDataDTO = new BranchDataDTO();
  userListExcelDownload: User[] = [];
  excelDownloadData: any = [];
 @Input("data") data: any;
  type = '';
  id = '';
  sNoCount: number;
  fullNameCount: number;
  phoneNumberCount: number;
  GenderCount: number;
  emailIdCount: number;
  qualificationCount: number;
  yearOfPassingCount: number;
permanentCount: number;
  currentPincodeCount: number;
  errorFieldArray: string[];

  constructor(public dialog: MatDialog,
    public driveEventService:DriveEventService,
    private excelService: ExcelService,
    private campaignService: CampaignService,
    private utility: UtilityService,
    private snackBarService: MatSnackBar,
    private route: ActivatedRoute) { }
//data;
  ngOnInit() {
   
   this.type = this.route.snapshot.paramMap.get('type');
    this.id = this.route.snapshot.paramMap.get('id');
    console.log('____drive event data_____',this.data)
  }

  getCollegeData() {
    this.utility.showSpinner();
    this.campaignService.getDetailsByTypeAndId(this.type, this.id)
      .subscribe(response => {
        console.log("getDetailsByTypeAndId", response);
        this.data = (response as any).data;
        this.utility.hideSpinner();
      });
  }

  openAddAccessCodeDialog(branch) {
    console.log(branch);
    this.dialog.open(AddHiringDriveComponent, {
      disableClose : true,
      //width : '60em',
      //height : 'fit-content',
      data:{collegeDetail:this.data,
      branchName:branch},
      panelClass: "dialog-style"
    });
  }

  uploadHandler(event: any,college:any) {
    console.log(college);
    this.allUser = [];
    this.sNoCount = 0;
    this.fullNameCount = 0;
    this.phoneNumberCount = 0;
    this.GenderCount = 0 ;
    this.emailIdCount = 0 ;
    this.qualificationCount =  0;
    this.yearOfPassingCount = 0;
    this.permanentCount = 0 ;
    this.currentPincodeCount = 0;
    this.errorFieldArray = [];
 console.log(event.target.files[0]);
 const file: File = event.target.files[0];
 event.target.value = null;
 const fileReader = new FileReader();
 fileReader.readAsArrayBuffer(file);
 fileReader.onload = () => {

  this.arrayBuffer = fileReader.result;
  const tempData = new Uint8Array(this.arrayBuffer);
  const arr = new Array();

  for (let i = 0; i !== tempData.length; ++i) {
    arr[i] = String.fromCharCode(tempData[i]);
  }

  const bstr = arr.join('');
  const workbook = XLSX.read(bstr, { type: 'binary' });
  const first_sheet_name = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[first_sheet_name];

  this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

console.log('-->', this.excelData);

  for (const value of this.excelData) {

    const user: User = new User();
    user.rowNumber = value['S.NO'];
    if (user.rowNumber === undefined) {
      this.sNoCount++;
   }
    user.fullName = value['Full Name'];
    if (user.fullName === undefined) {
      this.fullNameCount++;
    }
    user.phoneNumber = value['Phone Number'];
    if (user.phoneNumber === undefined) {
      
      this.phoneNumberCount ++;
   }
    user.gender = value.Gender;
    if(user.gender === undefined) {
      this.GenderCount++;
    }
    user.emailId = value['Email id'];
    if (user.emailId === undefined) {
      this.emailIdCount ++;
    }
    user.qualification = value.Qualification;
    if (user.qualification === undefined) {
      this.qualificationCount ++;
    }
    user.graduationYear = value['Year Of Passing'];
    if (user.graduationYear === undefined) {
      this.yearOfPassingCount ++;
    }
   user.permanentPinCode = value['Permanent Pin Code'];
   if (user.permanentPinCode === undefined) {
     this.permanentCount ++;
   }
   user.currentPinCode = value['Current Pin Code'];
   if (user.currentPinCode === undefined ) {
      this.currentPincodeCount ++;
   }
   this.allUser.push(user);
 }
console.log('current count',this.currentPincodeCount);

 if(this.phoneNumberCount === this.allUser.length){
   // console.log('phone number column in excel sheet invalid');
   // this.snackBarService.open('phone number column in excel sheet invalid', 'close',{duration: 5000});
   this.errorFieldArray.push('Phone Number');
 } 
 if (this.sNoCount  === this.allUser.length) {
    this.errorFieldArray.push('sr. No');
 //  this.snackBarService.open('s.no column invalid in excel sheet', 'close', {duration: 5000});
 }
   if (this.fullNameCount  === this.allUser.length) {
     this.errorFieldArray.push('Full Name');
  // this.snackBarService.open('full name column invalid in excel sheet', 'close', {duration: 5000});
 }
  if (this.GenderCount  === this.allUser.length) {
    this.errorFieldArray.push('Gender');
  }
  if (this.emailIdCount  === this.allUser.length) {
    this.errorFieldArray.push('Email id');
 } 
  if (this.qualificationCount  === this.allUser.length) {
    this.errorFieldArray.push('Qualification');
   //this.snackBarService.open('qualification column invalid in excel sheet', 'close', {duration: 5000});
 }
  if (this.yearOfPassingCount  === this.allUser.length) {
    this.errorFieldArray.push('Year Of Passing');
  
 }
  if (this.permanentCount === this.allUser.length) {
    this.errorFieldArray.push('Permanent Pin Code');
  // this.snackBarService.open('permanent pin code column invalid in excel sheet', 'close', {duration: 5000});
 } 
  if (this.currentPincodeCount === this.allUser.length) {
    this.errorFieldArray.push('Current Pin Code')
   //this.snackBarService.open('current pin code column invalid in excel sheet', 'close', {duration: 5000});
 }
 
 
 if( this.errorFieldArray.length != 0) {
   console.log('error in column-->',this.errorFieldArray);
   
   this.dialog.open(ErrorStatusDialogComponent, {
     width: '60%',
     data:{ 
       response: this.errorFieldArray,
           errorFor: 'column'}
   });
 }  
 else{
 console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));

 // console.log('all user', this.allUser);
 this.branchDataDto.users = this.allUser;
 this.branchDataDto.branchId = college.id;
 console.log('all user', this.branchDataDto.users);
 console.log('got id', this.branchDataDto.branchId);
 console.log('excel data to upload--->',this.branchDataDto);
 this.campaignService.postExcelData(this.branchDataDto).subscribe(
   response => {
     this.utility.hideSpinner();
     console.log(response);
     // this.branchDataDto = null;
     this.allUser = [];
     if (response.data.validationStatus === true) {
       this.dialog.open(ErrorStatusDialogComponent, {
         width: '60%',
         data:{response:response,
         errorFor:'row'
         }
       });
     }
     if(response.data.validationStatus === false) {
       this.snackBarService.open('excel sheet upload successfully', 'close', {duration:4000});
     }
     // this.ngOnInit();


   }
 );
 }
};
}

  downloadHandler(values: any, name: any) {
    this.getCollegeData();
 const fileName: any = this.data.institutionName + '-' + name;
 this.userListExcelDownload = values;

 if (values.length === 0) {
   const excelDownloadModel: any = new class {
     'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
     'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''; 'Refferal Name': '';'Refferal Contact No': '';
   };

   excelDownloadModel['S.NO'] = '';
   excelDownloadModel['Full Name'] = '';
   excelDownloadModel['Phone Number'] = '';
   excelDownloadModel['Gender'] = '';
   excelDownloadModel['Email id'] = '';
   excelDownloadModel['Qualification'] = '';
   excelDownloadModel['Year Of Passing'] = '';
   excelDownloadModel['Registered Date'] = '';
   excelDownloadModel['Permanent Pin Code'] = '';
   excelDownloadModel['Current Pin Code'] = '';
   excelDownloadModel['Refferal Name'] = '';
   excelDownloadModel['Refferal Contact No'] = '';
   this.excelDownloadData.push(excelDownloadModel);
   this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
 } else {

   let rowNumber: number = 0;

   for (const response of this.userListExcelDownload) {
     const excelDownloadModel: any = new class {
       'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
       'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''; 'Refferal Name': '';'Refferal Contact No';
     };
     excelDownloadModel['S.NO'] = ++rowNumber;
     excelDownloadModel['Full Name'] = response.fullName;
     excelDownloadModel['Phone Number'] = response.phoneNumber;
     excelDownloadModel['Gender'] = response.gender;
     excelDownloadModel['Email id'] = response.emailId;
     excelDownloadModel['Qualification'] = response.qualification;
     excelDownloadModel['Year Of Passing'] = response.graduationYear;
     excelDownloadModel['Registered Date'] = response.registeredDate;
     excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
     excelDownloadModel['Current Pin Code'] = response.currentPinCode;
     excelDownloadModel['Refferal Name'] = response.referralName;
     excelDownloadModel['Refferal Contact No'] = response.referralContactNumber;
     this.excelDownloadData.push(excelDownloadModel);
   }
   this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
 }
 this.excelDownloadData = [];
}

}
